import React, { FC } from 'react';
import { AnimatedIcon } from '../../../../commons/AnimatedIcon';
import SuccessIconLight from '../../../../../assets/images/lottieIcons/success/success.light.json';
import SuccessIconDark from '../../../../../assets/images/lottieIcons/success/success.dark.json';
import { CustomMUIButton } from '../../../../commons/buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../../models/Common';

interface SuccessFormProps {
  handleClick: () => void;
  iconElement?: JSX.Element;
  additionalText: string | JSX.Element;
  btnLabel: string;
}

const defaultProps = {
  iconElement: <AnimatedIcon lightIcon={SuccessIconLight} darkIcon={SuccessIconDark} className="icon-success" />,
};

export const SuccessForm: FC<SuccessFormProps> = ({ handleClick, iconElement, additionalText, btnLabel }) => {
  return (
    <div className="success">
      {iconElement}
      <p className="success__text">{additionalText}</p>
      <div className="success-form">
        <div className="success-form__btn-group">
          <CustomMUIButton
            label={btnLabel}
            handleClick={handleClick}
            className={ButtonClassNames.PrimaryFulfilled}
            isBold
          />
        </div>
      </div>
    </div>
  );
};
SuccessForm.defaultProps = defaultProps;
